module.exports = __webpack_public_path__ + "img/cert-education.a12c31c5.png";